import { render, staticRenderFns } from "./RegisterUserLogin.vue?vue&type=template&id=d6b9afe2&"
import script from "./RegisterUserLogin.vue?vue&type=script&lang=ts&"
export * from "./RegisterUserLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports